var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "touch",
          rawName: "v-touch:swipe.left",
          value: _vm.slideNext,
          expression: "slideNext",
          arg: "swipe",
          modifiers: { left: true }
        },
        {
          name: "touch",
          rawName: "v-touch:swipe.right",
          value: _vm.slidePrev,
          expression: "slidePrev",
          arg: "swipe",
          modifiers: { right: true }
        }
      ],
      ref: "carousel",
      staticClass: "carousel"
    },
    [
      _vm.infinite
        ? _c(
            "div",
            {
              staticClass: "carousel__track carousel__track--clone",
              style: _vm.beforeTrackStyles
            },
            [_vm._t("clone-before")],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "carousel__track", style: _vm.trackStyles },
        [_vm._t("default")],
        2
      ),
      _vm.infinite
        ? _c(
            "div",
            {
              staticClass: "carousel__track carousel__track--clone",
              style: _vm.afterTrackStyles
            },
            [_vm._t("clone-after")],
            2
          )
        : _vm._e(),
      _vm.dots
        ? _c(
            "ul",
            { staticClass: "carousel__dots u-list-simple u-list-inline" },
            [
              _c(
                "li",
                _vm._l(_vm.slides.length, function(n) {
                  return _c(
                    "button",
                    {
                      key: n,
                      staticClass: "carousel__dots__button u-clear-button",
                      class: { "is-active": n === _vm.currentSlideIndex + 1 },
                      on: {
                        click: function($event) {
                          return _vm.slideTo(n - 1)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "u-hidden" }, [
                        _vm._v("Show Slide " + _vm._s(n))
                      ])
                    ]
                  )
                }),
                0
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }